import { useEffect, useState } from "react";
import styles from "./BottomNavigation.module.scss";
import {
  CarouselNextButton,
  CarouselPrevButton,
  useCarousel,
} from "@aleksundshantu.com/aunds-utils-react/primitives/carousel";

interface BottomNavigationProps {
  totalSnaps: number;
  hideFrom: "tablet" | "desktop" | "widescreen";
  initialIndex?: number;
}
{
  /* jscpd:ignore-start */
}
export const BottomNavigation = ({
  totalSnaps,
  hideFrom,
  initialIndex,
}: BottomNavigationProps) => {
  const { emblaApi } = useCarousel();

  const [selectedIndex, setSelectedIndex] = useState(initialIndex || 1);

  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap() + 1);
    };

    emblaApi.on("select", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi]);
  return (
    <div
      className={`${styles["bottom-navigation"]} ${styles[`hide-from-${hideFrom}`]} bottom-navigation`}
    >
      <div className={styles["naviagtion-snaps"]}>
        <CarouselPrevButton />
        <span>
          {selectedIndex} / {totalSnaps}
        </span>
        <CarouselNextButton />
      </div>
    </div>
  );
};
/* jscpd:ignore-end */
